module.exports = __webpack_public_path__ + "fonts/Extenda-40Hecto.5e77564.woff2";